module.exports = __webpack_public_path__ + "images/ds-fa2024-bg-banner-mobile.webp";